import { HttpClient } from './serviceBase';
import { utils } from "../utils/utils"


const MapCreate = (stockControl, warehouseId, branchCode, createdBy) => ({
    details: stockControl.details,
    warehouseId,
    branchCode,
    createdBy
})

const MapUpdate = (stockControl, warehouseId = null) => ({
    id: stockControl.id,
    details: stockControl.details,
    state: stockControl.state,
    warehouseId
})

class StockControlService {
    Search = async (queryString) =>
        await HttpClient.Get(`/api/stockControls${queryString}`);

    Create = async (stockControl, warehouseId, branchCode, createdBy) =>
        await HttpClient.Post(`/api/stockControls`, MapCreate(stockControl, warehouseId, branchCode, createdBy));

    Update = async (stockControl) =>
        await HttpClient.Put(`/api/stockControls/${stockControl.id}`, MapUpdate(stockControl));

    Get = async (stockControlId) =>
        await HttpClient.Get(`/api/stockControls/${stockControlId}`);

    CreateAdjustment = async (stockControl, warehouseId) =>
        await HttpClient.Post(`/api/stockControls/${stockControl.id}/adjustments`, MapUpdate(stockControl, warehouseId));

    BuildExcel = async (request) =>
        await HttpClient.PostFile(`/api/stockControls/buildExcel`, request);

    GetWarehouseById = async (warehouseId) =>
        await HttpClient.Get(`/api/warehouse/GetWarehouseById/${warehouseId}`);

    GetWarehouses = async (request) => {
        const queryString = utils.GetQueryStringsFromObject(request);
        return await HttpClient.Get(`/api/warehouse/SearchWarehouse?${queryString}`);
    }
}

export default new StockControlService();